import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

const baseSwiperOptions = {
  loop: true,
  spaceBetween: 30,
  autoplay: {
    delay: 3000,
    disableOnInteraction: false,
  },
  speed: 2000,
  watchSlidesVisibility: true,
};

/**
 * ナビゲーションボタン付きの Swiper を生成
 */
export function createSwiperWithNav(selector, nextEl, prevEl, extraOptions = {}) {
  return new Swiper(selector, {
    ...baseSwiperOptions,
    navigation: { nextEl, prevEl },
    ...extraOptions,
  });
}

/**
 * ページネーション付きの Swiper を生成
 */
export function createSwiperWithPagination(selector, paginationEl, extraOptions = {}) {
  return new Swiper(selector, {
    ...baseSwiperOptions,
    pagination: { el: paginationEl, clickable: true },
    ...extraOptions,
  });
}
